import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';
import Cookies from 'js-cookie';

export const GetInputParams = async (setLoading) => {
  setLoading('loading');
  const IdPerson =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.IdPerson;

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_PATO_GET_LRC_FILTER_PARAM}`,
    true,
    {
      idPerson: IdPerson,
    }
  ).then((response) => {
    // console.log('response is =>', response);
    if (response.data.resCode === 1) {
      setLoading(response.data.Data);
    } else {
      SwalAlert('error', response.data.resMessage, false);
      setLoading(null);
    }
  });
};
